<template>
  <modal-template>
    <template #header>
      <div class="modal-header-style">
        <div style="float:left;padding-left:1%;padding-top:1%;font-weight:bold;font-size:larger;font-style:italic;">
          <span>cancel order</span>
        </div>
        <div style="float:right;">
          <label class="action-icon-style" v-on:click="$emit('close', true)">
            <font-awesome-icon icon="xmark" size="xl"/>
            <span style="display: block;">close</span>
          </label>
        </div>
      </div>
      <div style="width:100%;float:left;">
        <div style="font-size:larger;font-weight:bold;"><sup>[{{ customerId }}]</sup> {{ customerName }}
        </div>
        <div>serviced by <sup>[{{ dairyId }}]</sup> {{ dairyName }}</div>
      </div>
      <div style="width:100%;float:left;text-align:center;font-size:larger;font-weight:bold;">
        <p>Are you sure you want to cancel this submitted order?</p>
      </div>
    </template>
    <template #body>
      <div>
        <div style="font-weight:bold;">
          <div>
            <label>deliver on:</label><span>{{
              order.deliveryDate.substring(5, 7) + '/' +
              order.deliveryDate.substring(8, 10) + '/' +
              order.deliveryDate.substring(0, 4)
            }}</span>
          </div>
          <div v-if="order.purchaseOrder">
            <label>po#:</label><span>{{ order.purchaseOrder }}</span>
          </div>
          <div>
            <label>placed by:</label><span>{{ order.placedBy }}</span>
          </div>
          <div>
            <label>placed on:</label><span>{{
              order.placedOn.substring(5, 7) + '/' +
              order.placedOn.substring(8, 10) + '/' +
              order.placedOn.substring(0, 4)
            }}</span>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div style="float:right;">
        <button v-on:click="cancelOrder">yes</button>
      </div>
    </template>
  </modal-template>
</template>

<script>
import ModalTemplate from '@/components/ModalTemplate'

export default {
  name: 'Cancel',
  components: {
    ModalTemplate,
  },
  props: ['dairyId', 'dairyName', 'customerId', 'customerName', 'order', 'username'],
  emits: ['close', 'apierror', 'apierrortext'],
  data: function () {
    return {
    }
  },
  methods: {
    cancelOrder() {
      this.axios
          .post('orders/cancel', {
                dairyId: this.order.dairyId,
                accountId: this.order.accountId,
                deliveryType: this.order.deliveryType,
                orderId: this.order.orderId,
                deliveryDate: this.order.deliveryDate,
                purchaseOrder: this.order.purchaseOrder,
                placedBy: this.order.placedBy,
                placedOn: this.order.placedOn,
                priceDeck: this.order.priceDeck,
                orderDatePricing: this.order.orderDatePricing,
                cancelled: true,
                noOrder: this.order.noOrder,
                cutOff: this.order.cutOff,
                products: this.order.products,
              }
          )
          .catch(error => {
            this.$emit('apierror', true)
            this.$emit('apierrortext', error.response.statusText)
          })
          .finally(() => {
            this.$emit('close', true)
          })
    },
  },
}
</script>

<style scoped>
.modal-header-style {
  width: 100%;
  float: left;
  background: black;
  color: white;
  border-radius: 4px;
}

.action-icon-style {
  color: white;
  text-align: center;
  cursor: pointer;
  width: 80px;
}

.action-icon-style:hover {
  font-weight: bolder;
}
</style>
